import React from 'react';
import { Box, useTheme } from '@mui/material';

const DigitSkeleton = () => {
  const { palette, spacing } = useTheme();

  return (
    <Box
      component="span"
      sx={{
        display: 'inline-block',
        width: spacing(0.865),
        height: spacing(1.75),
        marginInlineStart: spacing(0.125),
        bgcolor: palette.grey[100]
      }}
    />
  );
};
const TestDateTimeSkeleton = () => (
  <Box color="grey.300">
    <DigitSkeleton />
    <DigitSkeleton />
    {'.'}
    <DigitSkeleton />
    <DigitSkeleton />
    {'.'}
    <DigitSkeleton />
    <DigitSkeleton />
    <DigitSkeleton />
    <DigitSkeleton />
    {','}
    <span>&nbsp;</span>
    <DigitSkeleton />
    <DigitSkeleton />
    {':'}
    <DigitSkeleton />
    <DigitSkeleton />
  </Box>
);

export default TestDateTimeSkeleton;
